import { render, staticRenderFns } from "./mapaOpRegRt.vue?vue&type=template&id=0743ffa2&scoped=true&"
import script from "./mapaOpRegRt.vue?vue&type=script&lang=js&"
export * from "./mapaOpRegRt.vue?vue&type=script&lang=js&"
import style0 from "./mapaOpRegRt.vue?vue&type=style&index=0&id=0743ffa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0743ffa2",
  null
  
)

export default component.exports